import { render, staticRenderFns } from "./centerAllocationPdf.vue?vue&type=template&id=0dd93dff&scoped=true&"
import script from "./centerAllocationPdf.vue?vue&type=script&lang=js&"
export * from "./centerAllocationPdf.vue?vue&type=script&lang=js&"
import style0 from "./centerAllocationPdf.vue?vue&type=style&index=0&id=0dd93dff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd93dff",
  null
  
)

export default component.exports